import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { SearchService } from '../../_services/search.service';
import { UserService } from '../../_services/user.service';
import { Feedback } from '@ivoviz/feedback.js';
import { environment } from '../../../environments/environment';
import { OntologyTreeService } from '../../_services/ontology-tree.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})


export class MenuComponent implements OnInit {
  notificationCount: number = 0;
  trashStatus: boolean = false;
  showNotification: boolean = false;

  @Input() searchText: String;




  public profile_pic;

  constructor(private searchService: SearchService, public userService: UserService,
    public _treeService: OntologyTreeService,) {

    this.userService.UserImgUpdateEvent.subscribe((img) => {
      this.profile_pic = img;
    });
    this.userService.UserNameUpdateEvent.subscribe(() => {
      this.profile_pic = this.userService.currentUser.avatar;
    });
  }

  ngOnInit() {
    this.profile_pic = this.userService.currentUser.avatar;

  }

  searchInputChanged() {
    this.searchService.searchInputChange.emit(this.searchText)
  }

  gotoHelp() {
    window.open('docs/');
  }

  newFeedback() {
    const feedback = new Feedback({ 'endpoint': environment.communication_service_api +
     'feedback?userId=' + this.userService['currentUser']['_id'] }, {
      allowTaint: false
    });
    feedback.open();
  }

  toggleNotification(){
    this.showNotification = !this.showNotification;
  }
  notificationCountUpdated($event){
    this.notificationCount = $event
  }

  clearProjectCache() {
    this._treeService.ontologyNodeReloadEvent.emit(false);
  }

}
